import React from "react";
import Announcements from "./pages/Announcements/Announcements";
import BalanceDueUpload from "./pages/Accounting/BalanceDueUpload";
import BrokerMetrics from "./pages/BrokerMetrics/BrokerMetrics";
import Classes from "./pages/Classes/Classes";
import Contracts from "./pages/Contracts/Contracts";
import Contract from "./pages/Contracts/Contract";
import Dashboard from "./pages/Dashboard/Dashboard";
import DocumentMapper from "./pages/DocumentMapper/DocumentMapper";
import Features from "./pages/Features/Features";
import Fine from "./pages/Fines/Fine";
import Fines from "./pages/Fines/Fines";
import Franchise from "./pages/Franchises/Franchise";
import Franchises from "./pages/Franchises/Franchises";
import Faqs from "./pages/Faqs/Faqs";
import FaqCategories from "./pages/FaqCategories/FaqCategories";
import DownloadInstances from "./pages/DownloadInstances/DownloadInstances";
import FranchiseReport from "./pages/FranchiseReport/FranchiseReport";
import FranchiseReports from "./pages/FranchiseReports/FranchiseReports";
import FormBuilder from "./pages/FormBuilder/FormBuilder";
import GlobalFiles from "./pages/GlobalFiles/GlobalFiles";
import GlobalSettings from "./pages/GlobalSettings/GlobalSettings";
import GmailGroups from "./pages/GmailGroups/GmailGroups";
import Members from "./pages/Members/Members";
import RSAMenuSettings from "./pages/RSAMenuSettings/RSAMenuSettings";
import MailMergeTemplates from "./pages/MailMergeTemplate/MailMergeTemplates";
import MailMergeTemplate from "./pages/MailMergeTemplate/MailMergeTemplate";
import ManageReports from "./pages/ManageReports/ManageReports";
import MasterBlaster from "./pages/Services/Franchises/MasterBlaster/MasterBlaster";
import MarketplaceVendor from "./pages/Marketplace/MarketplaceVendors/MarketplaceVendor";
import MarketplaceVendors from "./pages/Marketplace/MarketplaceVendors/MarketplaceVendors";
import MarketplaceCategories from "./pages/Marketplace/MarketplaceCategories/MarketplaceCategories";
import MlsProvider from "./pages/MlsProviders/MlsProvider";
import MlsProviders from "./pages/MlsProviders/MlsProviders";
import News from "./pages/News/News";
import CommunicationGroups from "./pages/CommunicationGroups/CommunicationGroups";
import RealEstateBoard from "./pages/RealEstateBoards/RealEstateBoard";
import RealEstateBoards from "./pages/RealEstateBoards/RealEstateBoards";
import RoyaltyPlanTemplate from "./pages/RoyaltyPlanTemplates/RoyaltyPlanTemplate";
import RoyaltyPlanTemplates from "./pages/RoyaltyPlanTemplates/RoyaltyPlanTemplates";
import Territories from "./pages/Territories/Territories";
import TransactionDocumentSetup from "./pages/TransactionDocumentSetup/TransactionDocumentSetup";
import UserManagement from "./pages/UserManagement/UserManagement";
import ActivityPlans from "./pages/ActivityPlans/ActivityPlans";
import ActivityPlan from "./pages/ActivityPlans/ActivityPlan";
import ActivityTemplate from "./pages/ActivityPlans/ActivityTemplate";
import FranchiseRoles from "./pages/FranchiseRoles/FranchiseRoles";
import FranchiseRole from "./pages/FranchiseRoles/FranchiseRole";
import FranchiseProductsTemplates from "./pages/Accounting/FranchiseProductsTemplates";
import ProductAccounts from "./pages/Accounting/ProductAccounts";
import AgentListReport from "./pages/AgentListReport/AgentListReport";
import SidesVolumeExport from "./pages/SidesVolumeExport/SidesVolumeExport";
import SmartDocsMapping from "./pages/SmartDocsMapping/SmartDocsMapping";
import SurveyTemplate from "./pages/SurveyTemplates/SurveyTemplate";
import SurveyTemplates from "./pages/SurveyTemplates/SurveyTemplates";
import VideoCourses from "./pages/VideoCourses/VideoCourses";
import TransactionDetails from "./pages/TransactionDetails/transactionDetails";
import Home from "./pages/Home/Home";
import DepartmentOfRealEstate from "./pages/DepartmentOfRealEstate/DepartmentOfRealEstate";

const routes = {
  "/accounting/balanceDueUpload": () => <BalanceDueUpload />,
  "/accounting/franchiseProductsTemplates": () => (
    <FranchiseProductsTemplates />
  ),
  "/accounting/productAccounts": () => <ProductAccounts />,
  //"/accounting/homeSmartPlus/achRequests": () => <AchRequests />,
  "/announcements": () => <Announcements />,
  "/brokerMetrics": () => <BrokerMetrics />,
  "/agentListExport": () => <AgentListReport />,
  "/sidesVolumeExport": () => <SidesVolumeExport />,
  "/transactionDetails": () => <TransactionDetails />,
  "/companyNews": () => <News />,
  "/communicationGroups": () => <CommunicationGroups />,
  "/classes": () => <Classes />,
  "/contracts": () => <Contracts />,
  "/contracts/new": () => <Contract />,
  "/contracts/edit/:contractId": ({ contractId }) => (
    <Contract contractId={contractId} />
  ),
  "/dashboard": () => <Dashboard />,
  "/documents": () => <GlobalFiles />,
  "/": () => <Home />,
  "/faqs": () => <Faqs />,
  "/faqCategories": () => <FaqCategories />,
  "/downloadInstances": () => <DownloadInstances />,
  "/features": () => <Features />,
  "/fines": () => <Fines />,
  "/fines/new": () => <Fine />,
  "/fines/edit/:fineId": ({ fineId }) => <Fine fineId={fineId} />,
  "/instances/new": () => <Franchise />,
  "/instances/edit/:franchiseId": ({ franchiseId }) => (
    <Franchise franchiseId={franchiseId} />
  ),
  "/smartdocsMapping": () => <SmartDocsMapping />,
  "/surveyTemplates": () => <SurveyTemplates />,
  "/surveyTemplate/edit/:id": ({ id }) => (
    <SurveyTemplate surveyTemplateId={id} />
  ),
  "/surveyTemplate/new": () => <SurveyTemplate />,
  "/videoCourses": () => <VideoCourses />,

  "/activityPlans": () => <ActivityPlans />,
  "/activityPlan/new": () => <ActivityPlan />,
  "/activityPlan/edit/:activityPlanId": ({ activityPlanId }) => (
    <ActivityPlan activityPlanId={activityPlanId} />
  ),
  "/activityPlan/template/new/:name/:description/:category/:subcategory/:startdate/:enddate":
    ({ name, description, category, subcategory, startdate, enddate }) => (
      <ActivityTemplate
        name={name}
        description={description}
        category={category}
        subcategory={subcategory}
        startdate={startdate}
        enddate={enddate}
      />
    ),
  "/activityPlan/template/new/:name/:description/:category/:subcategory/:startdate":
    ({ name, description, category, subcategory, startdate }) => (
      <ActivityTemplate
        name={name}
        description={description}
        category={category}
        subcategory={subcategory}
        startdate={startdate}
      />
    ),
  "/activityPlan/template/new/:activityPlanId": ({ activityPlanId }) => (
    <ActivityTemplate activityPlanId={activityPlanId} />
  ),
  "/activityPlan/template/edit/:activityTemplateId": ({
    activityTemplateId,
  }) => <ActivityTemplate activityTemplateId={activityTemplateId} />,

  "/instances": () => <Franchises />,
  "/globalSettings": () => <GlobalSettings />,
  "/gmailGroups": () => <GmailGroups />,
  "/members/:id": ({ id }) => (
    <Members groupId={id} />
  ),
  "/rsaMenuSettings": () => <RSAMenuSettings />,
  "/mailMerge": () => <MailMergeTemplates />,
  "/mailMerge/edit/:mailMergeTemplateId": ({ mailMergeTemplateId }) => (
    <MailMergeTemplate mailMergeTemplateId={mailMergeTemplateId} />
  ),
  "/mailMerge/new": () => <MailMergeTemplate />,
  "/manageReports": () => <ManageReports />,
  "/marketplace/vendors": () => <MarketplaceVendors />,
  "/marketplace/vendors/new": () => <MarketplaceVendor />,
  "/marketplace/vendors/edit/:marketplaceVendorId": (marketplaceVendorId) => (
    <MarketplaceVendor queryParams={marketplaceVendorId} />
  ),
  "/marketplace/categories": () => <MarketplaceCategories />,
  "/mlsProviders/new": () => <MlsProvider />,
  "/mlsProviders/edit/:mlsProviderId": ({ mlsProviderId }) => (
    <MlsProvider mlsProviderId={mlsProviderId} />
  ),
  "/mlsProviders": () => <MlsProviders />,
  "/realEstateBoards/new": () => <RealEstateBoard />,
  "/realEstateBoards/edit/:realEstateBoardId": ({ realEstateBoardId }) => (
    <RealEstateBoard realEstateBoardId={realEstateBoardId} />
  ),
  "/realEstateBoards": () => <RealEstateBoards />,
  "/departmentOfRealEstate": () => <DepartmentOfRealEstate />,
  "/reports/report/:reportKey": ({ reportKey }) => (
    <FranchiseReport reportKey={reportKey} />
  ),
  "/reports": () => <FranchiseReports />,
  "/royaltyPlanTemplates/new": () => <RoyaltyPlanTemplate />,
  "/royaltyPlanTemplates/edit/:royaltyPlanTemplateId": ({
    royaltyPlanTemplateId,
  }) => <RoyaltyPlanTemplate royaltyPlanTemplateId={royaltyPlanTemplateId} />,
  "/royaltyPlanTemplates": () => <RoyaltyPlanTemplates />,
  "/territories": () => <Territories />,
  "/services/instances/masterBlaster": () => <MasterBlaster />,
  "/users": () => <UserManagement />,
  "/userroles": () => <FranchiseRoles />,
  "/userroles/edit/roles/:roleId": ({ roleId }) => (
    <FranchiseRole roleId={roleId} />
  ),

  "/documentMapper/:documentId/:instanceId": ({ documentId, instanceId }) => (
    <DocumentMapper documentId={documentId} instanceId={instanceId} />
  ),
  "/transactionDocumentSetup/edit/:documentId/:franchiseId": ({
    documentId,
    franchiseId,
  }) => (
    <TransactionDocumentSetup
      documentId={documentId}
      franchiseId={franchiseId}
    />
  ),
  "/transactionDocumentSetup/new/:franchiseId/:categoryId": ({
    franchiseId,
    categoryId,
  }) => (
    <TransactionDocumentSetup
      franchiseId={franchiseId}
      categoryId={categoryId}
    />
  ),
  "/formBuilder/:franchiseId": ({ franchiseId }) => (
    <FormBuilder franchiseId={franchiseId} />
  ),
};

export default routes;
